import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="w-full min-h-screen flex flex-col md:flex-row overflow-hidden">
      {/* Left — Off White */}
      <div className="relative w-full md:w-3/5 bg-[#F5F2ED] flex flex-col justify-center px-8 md:px-16 lg:px-24 pt-24 pb-16 md:pt-0 md:pb-0">
        {/* Brand anchor */}
        <div className="absolute top-8 left-8 md:top-10 md:left-12 lg:left-24">
          <p className="text-[10px] tracking-[0.3em] text-[#9C9490] uppercase font-medium">ALA / 株式会社ＡＬＡ</p>
        </div>

        {/* Main copy */}
        <div
          className={`transition-all duration-1000 delay-200 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <p className="text-2xl md:text-3xl font-light text-[#9C9490] tracking-wide mb-2">戦略で、</p>
          <p className="text-5xl md:text-7xl lg:text-8xl font-black text-[#0A0E1A] leading-none tracking-tighter mb-1">未来を</p>
          <p className="text-5xl md:text-7xl lg:text-8xl font-black text-[#0A0E1A] leading-none tracking-tighter mb-8">動かす。</p>

          <p className="text-sm md:text-base text-[#6B6560] leading-relaxed max-w-sm mb-10">
            コンサルティング・広告・空間デザイン・人材育成を通じて、<br className="hidden md:inline" />
            あなたのビジネスの可能性を最大化します。
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/services"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#C8501A] text-white text-sm font-medium rounded-full hover:bg-[#A83E10] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              サービスを見る
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-6 py-3 border border-[#0A0E1A] text-[#0A0E1A] text-sm font-medium rounded-full hover:bg-[#0A0E1A] hover:text-white transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              無料相談
            </Link>
          </div>
        </div>

        {/* Bottom stats */}
        <div
          className={`absolute bottom-10 left-8 md:left-16 lg:left-24 flex gap-10 transition-all duration-1000 delay-500 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <div>
            <p className="text-2xl font-black text-[#0A0E1A]">2019</p>
            <p className="text-xs text-[#9C9490] tracking-wider">設立</p>
          </div>
          <div>
            <p className="text-2xl font-black text-[#0A0E1A]">100+</p>
            <p className="text-xs text-[#9C9490] tracking-wider">支援領域</p>
          </div>
          <div>
            <p className="text-2xl font-black text-[#0A0E1A]">4</p>
            <p className="text-xs text-[#9C9490] tracking-wider">事業領域</p>
          </div>
        </div>
      </div>

      {/* Right — Deep Navy */}
      <div className="relative w-full md:w-2/5 bg-[#0A0E1A] flex flex-col justify-end overflow-hidden min-h-[320px] md:min-h-screen">
        {/* Background image */}
        <img
          src="https://readdy.ai/api/search-image?query=modern%20minimalist%20Japanese%20office%20interior%20professional%20consulting%20firm%20clean%20design%20dark%20moody%20lighting%20architectural%20details%202019%20era%20contemporary%20high%20end%20corporate%20space&width=600&height=900&seq=hero-right-1&orientation=portrait"
          alt="ALA オフィスイメージ"
          className="absolute inset-0 w-full h-full object-cover object-center opacity-40"
        />

        {/* Decorative rotating text */}
        <div
          className={`absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none transition-all duration-1000 delay-300 ${
            visible ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <p
            className="text-5xl md:text-6xl font-black text-white/10 tracking-tight whitespace-nowrap"
            style={{ writingMode: 'vertical-rl', textOrientation: 'mixed', transform: 'rotate(180deg)' }}
          >
            Consulting &amp; Advertising
          </p>
        </div>

        {/* Est. label */}
        <div className="absolute top-6 right-6 text-right">
          <p className="text-xs tracking-[0.3em] text-white/40 uppercase">Est.</p>
          <p className="text-2xl font-black text-white/30">2019</p>
        </div>

        {/* Bottom text */}
        <div
          className={`relative z-10 p-8 md:p-12 transition-all duration-1000 delay-400 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <p className="text-xs tracking-[0.3em] text-[#C8501A] uppercase mb-2">Kumamoto, Japan</p>
          <p className="text-2xl md:text-3xl font-black text-white leading-tight">
            東京発、<br />全国へ。
          </p>
          <div className="mt-6 w-12 h-0.5 bg-[#C8501A]" />
        </div>
      </div>
    </section>
  );
}
